/* La Colecție — social proof slider arrows (desktop). */
if (!customElements.get('lc-proof-slider')) {
  customElements.define('lc-proof-slider', class LcProofSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-lc-proof-slider]');
      this.prevButton = this.querySelector('[data-lc-proof-prev]');
      this.nextButton = this.querySelector('[data-lc-proof-next]');

      if (!this.track || !this.prevButton || !this.nextButton) return;

      this.columns = Number(this.dataset.columns) || 3;
      this.update = this.update.bind(this);
      this.frame = null;

      this.prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.goTo(this.currentIndex() - 1);
      });

      this.nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.goTo(this.currentIndex() + 1);
      });

      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.update();
          this.frame = null;
        });
      }, { passive: true });

      window.addEventListener('resize', this.update, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }

    step() {
      const firstItem = this.track.querySelector('figure');
      if (!firstItem) return 0;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      return firstItem.getBoundingClientRect().width + gap;
    }

    maxIndex() {
      return Math.max(0, this.track.querySelectorAll('figure').length - this.columns);
    }

    currentIndex() {
      const step = this.step();
      return step ? Math.round(this.track.scrollLeft / step) : 0;
    }

    update() {
      const index = this.currentIndex();
      this.prevButton.disabled = index <= 0;
      this.nextButton.disabled = index >= this.maxIndex();
    }

    goTo(index) {
      const step = this.step();
      if (!step) return;

      const target = Math.max(0, Math.min(this.maxIndex(), index));
      this.track.scrollTo({ left: target * step, behavior: 'smooth' });
      window.setTimeout(this.update, 350);
    }
  });
}
